module.exports = __webpack_public_path__ + "static/media/tumblr-social-media-svgrepo-com.26df7130.svg";